import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { ServiceDetailPage } from './pages/ServiceDetailPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProcessPage } from './pages/ProcessPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { ScrollProgress } from './components/ui/ScrollProgress';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollProgress data-id="element-1" />
      <Layout data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/leistungen" element={<ServicesPage data-id="element-7" />} data-id="element-6" />
          <Route path="/leistungen/:slug" element={<ServiceDetailPage data-id="element-9" />} data-id="element-8" />
          <Route path="/projekte" element={<ProjectsPage data-id="element-11" />} data-id="element-10" />
          <Route path="/arbeitsweise" element={<ProcessPage data-id="element-13" />} data-id="element-12" />
          <Route path="/ueber-uns" element={<AboutPage data-id="element-15" />} data-id="element-14" />
          <Route path="/kontakt" element={<ContactPage data-id="element-17" />} data-id="element-16" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}